import React, { Children } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import typeStyles from './style/type.css';
import generalStyles from './style/general.css';

/**
 * The list component provides a quick way wrap any number of text items. No
 * external styling is needed on the individual list items.
 */
export default function List({ type, children }) {
  const wrappedChildren = Children.map(children, (child, index) => {
    if (!child) {
      return null;
    }

    const lastItem = children.length - 1 === index;
    const classNames = cx(generalStyles.item, {
      [generalStyles.lastItem]: lastItem,
    });

    return (
      <li key={index} className={classNames}>
        {child}
      </li>
    );
  });

  const classNames = cx(generalStyles.list, typeStyles[type]);

  return <ul className={classNames}>{wrappedChildren}</ul>;
}

List.propTypes = {
  type: PropTypes.oneOf(['ordered', 'unordered']),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

List.defaultProps = {
  type: 'unordered',
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-list/List/index.js